import { CalendarChartProps } from './CalendarChart';
import LinearCalendarChart from './LinearCalendarChart';

export type TemperatureChartProps = CalendarChartProps & {
  dayValues: (number | null)[];
};

const TemperatureChart: React.FC<TemperatureChartProps> = ({
  dayLabels,
  dayValues,
  dayRange,
  periodDots,
  drawHollowPeriodDots,
  topLabels,
  showMonthLabels,
}) => {
  const nonNullValues = dayValues.filter((v): v is number => v !== null);
  const range: [number, number] =
    nonNullValues.length > 0 ? [Math.min(...nonNullValues), Math.max(...nonNullValues)] : [35.5, 38.5];

  const gridValues: number[] = [];
  for (let temp = Math.ceil(range[0]); temp <= range[1]; temp++) {
    gridValues.push(temp);
  }

  const gridValuesLight: number[] = [];
  if (range[1] - range[0] < 3) {
    for (let temp = Math.ceil(range[0] * 2) / 2; temp <= range[1]; temp = Math.round((temp + 0.5) * 10) / 10) {
      if (temp % 1 !== 0) gridValuesLight.push(temp);
    }
  }

  return (
    <LinearCalendarChart
      dayLabels={dayLabels}
      dayValues={dayValues}
      range={range}
      horizontalGridValues={gridValues}
      horizontalGridValuesLight={gridValuesLight}
      yRangeOverride={7.5}
      reverseColors
      dayRange={dayRange}
      periodDots={periodDots}
      drawHollowPeriodDots={drawHollowPeriodDots}
      topLabels={topLabels}
      showMonthLabels={showMonthLabels}
    />
  );
};

export default TemperatureChart;
